import { NgModule, ModuleWithProviders } from '@angular/core';
import { UserService } from './userservice';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { PublicuserService } from './publicuser.service';
import { LabelcardMgmtService } from './labelcard-mgmt.service';
import { FolderManagementService } from './folder-mgmt.service';
import { DocumentManagementService } from './manage-doc.service';
import { LogoManagementService } from './logo-mgmt.service';
import { EngagementManagementService } from './engagement-mgmt.service';
import { HomeService } from './home.service';
import { AppConfigService } from './app-config.service';
import { LanguageService } from './language.service';
import { CommonService } from './common.service'
import { ApplicationConfigurationService } from './application-configuration.service';
import { LinkMasterService } from './link-master.service';
import { MessageService } from 'primeng';
import { DocverHistoryService } from './docver-history.service';
import { MasterListService } from './master-list.service';
import { CustomMessageService } from './custom-message.service'

import { JurisdictionService } from './jurisdiction.service';
import { UserManagementService } from './user-management.service';
import { TopicCardService } from './topic-card.service';
import { LogoIconMgmtService } from './logo-icon-mgmt.service';
import { UserMemoryService } from './user-memory.service';
 
@NgModule({})
export class RDCServiceModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: RDCServiceModule,
      providers: [UserService,
        FolderManagementService,
        AppConfigService,
        LabelcardMgmtService,
        PublicuserService,
        DocumentManagementService,
        LogoManagementService,
        LogoIconMgmtService,
        EngagementManagementService,
        HomeService,
        LanguageService,
        CommonService,
        ApplicationConfigurationService,
        LinkMasterService,
        MessageService,
        DocverHistoryService,
        MasterListService,
        CustomMessageService,
        JurisdictionService,
        UserManagementService,
        TopicCardService,
        UserMemoryService,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
      ]
    };
  }
}
